"use client"

import { Info } from "lucide-react"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"

interface TenantReactivationNoticeDialogProps {
  tenantName: string | null
  onOpenChange: (open: boolean) => void
}

export function TenantReactivationNoticeDialog({
  tenantName,
  onOpenChange,
}: TenantReactivationNoticeDialogProps) {
  return (
    <AlertDialog open={tenantName !== null} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-2">
            <Info className="h-5 w-5 text-blue-600" aria-hidden="true" />
            <AlertDialogTitle>Tenant activated</AlertDialogTitle>
          </div>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <p>
                <strong>{tenantName}</strong> <span>can access its workspace again.</span>
              </p>
              <p>
                Its Voice, Email, and Messaging Agents remain disabled and will
                not handle calls, emails, or messages automatically.
              </p>
              <p>
                Switch to this tenant, then reactivate every agent it should use
                from the corresponding Agents page.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction>Understood</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
